<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content medicine-dosage-dialog">
  <p class="medicine-dosage-dialog__intro">{{ data.message }}</p>
  <form [formGroup]="dosageUnitForm">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Unit</mat-label>
        <input required formControlName="unit" type="text" matInput>
        @if (dosageUnitForm.get('unit')?.invalid) {
          <mat-error>Unit is invalid</mat-error>
        }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Symbol</mat-label>
        <input required formControlName="symbol" type="text" matInput>
        @if (dosageUnitForm.get('symbol')?.invalid) {
          <mat-error>Symbol is invalid</mat-error>
        }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Code</mat-label>
        <input required formControlName="code" type="text" matInput>
        @if (dosageUnitForm.get('code')?.invalid) {
          <mat-error>Code is invalid</mat-error>
        }
      </mat-form-field>
    </p>
  </form>
</div>
<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button type="button" [disabled]="!dosageUnitForm.valid" mat-flat-button color="primary" (click)="createDosageUnit()">Create</button>
</div>
